import { TableColumn } from "../../../../components/ModularDataTable/types"
import { Input } from "../../../../components/Input/Input";
import { AggregatorPublicity } from "../agregador-publicity.type";
import moment from 'moment-timezone'
import { i18n } from "../../../../translate/i18n";


type Props = {
    switchStatus: (params: { endpoint: string, Id: number, status: boolean }) => void
}

export const createColumns = ({ switchStatus }: Props): TableColumn[] => {
    const columns: TableColumn[] = [
        {
            key: i18n.t(`aggregador_publicity.table.image`),
            value: 'shareImage',
            type: 'custom',
            render: (_value: any, row: AggregatorPublicity) => (
                <img src={row.image} style={{ width: `50px`, height: '50px', objectFit: "cover", borderRadius: '10px' }} />

            ),
        },
        {
            key: i18n.t(`aggregador_publicity.table.title`),
            value: 'title',
            type: 'text',
        },
        {
            key: i18n.t(`aggregador_publicity.table.description`),
            value: 'description',
            type: 'text',
        },
        {
            key: i18n.t(`aggregador_publicity.table.periodo`),
            value: 'slug',
            type: 'custom',
            align: 'left',
            render: (_value: any, row: AggregatorPublicity) => (
                <div>
                    <span>{moment(row.startDate).format('DD/MM/YYYY')} - {moment(row.endDate).format('DD/MM/YYYY')}</span>
                </div>
            ),
        },
        {
            key: i18n.t(`aggregador_publicity.table.status`),
            value: 'status',
            type: 'custom',
            align: 'center',
            render: (_value: any, row: AggregatorPublicity) => (
                <div>
                    <Input
                        value={row.status}
                        checked={row.status}
                        change={(val: boolean) => {
                            switchStatus({ endpoint: 'product', Id: row.id, status: val })
                        }}
                        inputAttr={{ type: 'checkbox' }}
                        checkSwift={true}
                    />
                </div>
            ),
        },
    ]

    return columns
}